
import { ref, defineComponent, onMounted, computed, watchEffect } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  props: {
    investmentOpportunitiesMain: {
      required: true,
      type: Object,
    },
    fromConnectedInvestmentOpportunities: {
      type: Boolean,
    },
  },
  components: {},
  setup(props, { emit }) {
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const hasInvestorRole = computed(() => {
      return user.value?.userRoles?.some(
        (role) => role.name.toLowerCase() == "investor"
      );
    });
    const truncateText = (text, limit) => {
      return (text ?? "")?.substr(0,limit)
    }
    const investmentOpportunities = ref<Record<string, unknown>>({});
    let connectedIds = ref<Record<string, unknown>>({});
    const refresh = async () => {
      try {
        const response = await store.dispatch(
          Actions.CONNECTED_INVESTMENT_OPPORTUNITIES
        );
        if (!response.success) throw new Error();
        connectedIds.value = {};
        for (let i = 0; i < response.data.length; i++) {
          connectedIds.value[response.data?.[i]?.founderBusiness?.id] = true;
        }
      } catch (err) {
        //
      }
    };
    onMounted(() => {
      refresh();
    });
    watchEffect(() => {
      investmentOpportunities.value = props.investmentOpportunitiesMain;
    });
    const decline = async (id) => {
      try {
        const response = await store.dispatch(
          Actions.INVESTMENT_OPPORTUNITY_DECLINE,
          id
        );
        if (!response?.success) throw new Error(response?.data?.message);
        store.commit("setAlert", {
          message: "Investment Opportunity Declined",
          subMessage: "",
          variant: "success",
          duration: 4000,
          show: true,
        });
        store.dispatch(Actions.AUTH_USER);
        emit("declined");
      } catch (err) {
        store.commit("setAlert", {
          message: err,
          subMessage: "",
          variant: "danger",
          duration: 4000,
          show: true,
        });
      }
    };
    return {
      truncateText,
      decline,
      investmentOpportunities,
      connectedIds,
      props,
      refresh,
      hasInvestorRole,
    };
  },
});
